import { IMedsusDiretrizForm } from '../../../../../../modules/types/MedsusNew';

export const defaultMedsusDiretrizFormMain: IMedsusDiretrizForm = {
  ////////////////////////////////////////
  // Identificador
  id: 0,

  ////////////////////////////////////////
  // Chaves estrangeiras
  sesId: 0,
  setorDafId: 0,

  ////////////////////////////////////////
  // Status e classificação
  status: 0,
  tipo: 0,
  respAquisicao: 0,
  respFinanciamento: 0,
  grupoFinanciamento: 0,
  componenteAF: 0,
  abrangencia: 0,
  respRegistro: 0,

  ////////////////////////////////////////
  // Dados principais da Diretriz
  nome: '',
  descricao: '',

  ////////////////////////////////////////
  // Links informacionais
  linkCidadao: '',
  linkFarmaceutico: '',

  ////////////////////////////////////////
  // Datas
  dataIncorporacao: '',
  dataDisponibilizacao: '',
  dataExclusao: '',

  ////////////////////////////////////////
  // Observações
  observacoes: '',
};
